const currentEnv =
  process.env['NX_BUILD_TARGET'] === 'client:build:production'
    ? 'production'
    : process.env['NX_BUILD_TARGET'] === 'client:build:development'
      ? 'development'
      : 'local'

// eslint-disable-next-line no-console
console.log('Current build target:', process.env['NX_BUILD_TARGET'])

const LocalEnvironment = {
  environment: currentEnv,
  production: currentEnv === 'production',
  auth: {
    authority: `https://auth.dev-kistill.hosting.apro.is`,
    client_id: 'KistillVefur',
    redirect_uri: `http://localhost:4200/signin-oidc`,
    response_type: 'code',
    scope: 'openid profile KistillApi',
  },
  graphqlPath: `http://localhost:3333/Graphql`,
  datadog: {
    clientToken: 'pub74d43b0465c10167f575d787c1e65816',
    env: currentEnv,
    force: true,
  },
  apiPath: '',
}

const hostmap = {
  development: 'dev-kistill.hosting.apro.is',
  production: 'kistill.is',
}
const locationHost = hostmap[currentEnv as keyof typeof hostmap]

const RunningEnvironment = {
  environment: currentEnv,
  production: currentEnv === 'production',
  auth: {
    authority: `https://auth.${locationHost}`,
    client_id: 'KistillVefur',
    redirect_uri: `https://${locationHost}/signin-oidc`,
    response_type: 'code',
    scope: 'openid profile KistillApi',
  },
  graphqlPath: `https://graphql.${locationHost}/graphql`,
  datadog: {
    clientToken: 'pub74d43b0465c10167f575d787c1e65816',
    env: currentEnv,
    force: true,
  },
  apiPath: `https://api.${locationHost}`,
}

export const environment =
  currentEnv === 'local' ? LocalEnvironment : RunningEnvironment
